import type {Configuration, PopupRequest} from '@azure/msal-browser';

// Config object to be passed to Msal on creation
export const msalConfig : Configuration = {
    auth: {
        authority: `https://login.microsoftonline.com/${import.meta.env.VITE_APP_AAD_TENANT_ID}`,
        clientId: import.meta.env.VITE_APP_AAD_CLIENT_ID,
        redirectUri: '/',
        postLogoutRedirectUri: '/',
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        allowNativeBroker: false,
    },
};

// Add here scopes for deliverableId token to be used at MS Identity Platform endpoints.
export const loginRequest : PopupRequest = {
    scopes: ['User.Read'],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
